export const textcontent = {
  heading: {
    de: "das rad",
    en: "the wheel"
  },
  inputplaceholder: {
    de: "Lösung hier eingeben",
    en: "type your solution here"
  },
  validationunset: {
    de: "Gib die Lösung des Rätsels in das Textfeld ein",
    en: "Enter he solution of the riddle in the textbox"
  },
  validationsuccess: {
    de: "Juhu! Die Lösung ist Richtig. Das Final findest du bei: ",
    en: "Wohoo! Your solution is correct. You'll finde the final at: "
  },
  validationfail: {
    de: "Leider falsch :(! Versuche es einfach noch einamal",
    en: "Wrong answer :( ! Try another solution."
  },
  solutionstitle: {
    de: "Letzte Versuche",
    en: "Recent Attempts"
  }
}